import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useSuperAdminRoles } from "../../../context/SuperAdmin/RolesContext";
import { StyledTableCell } from "../../../ui-components/StyledTables";
import ProfileRowRole from "./ProfileRowRole";
import { useAuthContext } from "../../../hooks/Auth";

const RolesTable = () => {
  const { roles } = useSuperAdminRoles();
  const { canAccess } = useAuthContext();
  return (
    <TableContainer
      sx={{
        width: "100%",
        margin: "auto",
        borderRadius: 2,
        overflow: "hidden",
        mt: 2,
      }}
    >
      <Table sx={{ minWidth: 500, width: "100%" }}>
        <TableHead sx={{ height: 20, width: "100%" }}>
          <TableRow>
            <StyledTableCell align="center">N°</StyledTableCell>
            <StyledTableCell align="center">Nombre</StyledTableCell>
            <StyledTableCell align="center">Fecha de creación</StyledTableCell>
            {canAccess("edit:role") && <StyledTableCell align="center">Estado</StyledTableCell>}
            <StyledTableCell align="center">Acciones</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {roles.length > 0 ? (
            roles.map((role, index) => (
              <ProfileRowRole key={index} role={role} i={index + 1} />
            ))
          ) : (
            <TableRow>
              <StyledTableCell
                colSpan={9}
                sx={{
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                }}
              >
                No hay campos aún
              </StyledTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RolesTable;
